import { render, staticRenderFns } from "./Desktop.vue?vue&type=template&id=cf260f2e&scoped=true&"
import script from "./Desktop.vue?vue&type=script&lang=js&"
export * from "./Desktop.vue?vue&type=script&lang=js&"
import style0 from "./Desktop.vue?vue&type=style&index=0&id=cf260f2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf260f2e",
  null
  
)

export default component.exports